import React from 'react';
import PropTypes from 'prop-types';
import sortBy from 'lodash/sortBy';
import styled from 'styled-components';

const LayoutDiv = styled.div`  
  align-self: ${( { item } ) => item.vAlign ? item.vAlign : 'center' };
  background-image: ${( { item } ) => `url(${ item.photo && item.photo.url && item.photo.url})` };
  background-position: ${( { item } ) => item.imagePosition && item.imagePosition.toLowerCase() };
  background-repeat: no-repeat;
  background-size: ${( { item } ) => item.imageAppearance && item.imageAppearance.toLowerCase() };
  color: ${( { item } ) => item.color };
  font-family: Alegreya, serif;
  grid-column-end: ${( { item } ) => item.columnEnd };
  grid-column-start: ${( { item } ) => item.columnStart };
  grid-row-end: ${( { item } ) => item.rowEnd };
  grid-row-start: ${( { item } ) => item.rowStart };
  height: ${( { supportsGrids, item } ) => supportsGrids ? '100%' : item.height };
  justify-self: ${( { item } ) => item.hAlign ? item.hAlign : 'center' };
  margin-left: ${( { supportsGrids, layouts } ) => supportsGrids ? 0 : parseInt(layouts.gridGap, 10) / 2 };
  margin-right: ${( { supportsGrids, layouts } ) => supportsGrids ? 0 : parseInt(layouts.gridGap, 10) / 2 };
  max-height: calc(100vh - 50px);
  max-width: 100vw;
  place-self: ${( { supportsGrids, flexValign } ) => supportsGrids ? '' : flexValign };
  padding: ${( { item } ) => item.padding };
  text-align: left;
  width: ${( { supportsGrids, item } ) => supportsGrids ? '100%' : item.width };
  
  @media (min-width: 769px) {
    max-height: calc(100vh - 100px);
  }
`;

const Caption = styled.div`
  bottom: ${({ layouts }) => layouts.caption && layouts.caption.position.bottom || 'auto' };
  height: ${({ layouts }) => layouts.caption && layouts.caption.position.height || 'auto' };
  left: ${({ layouts }) => layouts.caption && layouts.caption.position.left || 'auto' };
  right: ${({ layouts }) => layouts.caption && layouts.caption.position.right || 'auto' };
  top: ${({ layouts }) => layouts.caption && layouts.caption.position.top || 'auto' };
  width: ${({ layouts }) => layouts.caption && layouts.caption.position.width|| 'auto' };
  position: fixed;
  color: ${({ layouts }) => layouts.caption && layouts.caption.color };
  font-size: ${({ deviceType }) => deviceType === 'mobile' ? '16px' : '20px' };
  line-height: ${({ deviceType }) => deviceType === 'mobile' ? '22px' : '30px' };
`;

const Container = styled.div`
      display: ${({ supportsGrids }) => supportsGrids ? 'grid' : 'flex' };
      background-color: #333333;
      height: 100%;
      width: 100%;
      grid-gap: ${( { layouts } ) => layouts.gridGap };
      grid-template-columns: ${( { columnCount } ) => columnCount };
      grid-template-rows: ${( { rowCount } ) => rowCount };
`;

const Title = styled.h3`
      color: ${({ layouts }) => layouts.caption && layouts.caption.color };
      font-size: ${({ deviceType }) => deviceType === 'mobile' ? '20px' : '28px' };
      margin-bottom: 5px;
`;

const Layout = ({ layouts, supportsGrids, deviceType }) => {

    const columnCount = layouts.numberOfColumns.toString().length ? new Array(Number(layouts.numberOfColumns) + 1).join('1fr ').trim() : '1fr';
    const rowCount = layouts.numberOfRows.toString().length ? new Array(Number(layouts.numberOfRows) + 1).join('1fr ').trim() : '1fr';

    const markup = sortBy(layouts.columns, 'weight').map((item, index) => {
      let flexValign;
      if (item.vAlign === 'top') {
        flexValign = 'flex-start'
      } else {
        if (item.vAlign === 'bottom') {
          flexValign = 'flex-end'
        }
      }

      return (
          <LayoutDiv key={`layout-${index}`}
                     layouts={ layouts }
                     item={ item }
                     data-weight={ item.weight }
                     className="layout"
                     supportsGrids={ supportsGrids }
                     flexValign={ flexValign }
          >
            <Caption layouts={ layouts } deviceType={ deviceType }>
              <Title layouts={ layouts } deviceType={ deviceType }>{ layouts.caption && layouts.caption.title }</Title>
              { layouts.caption && layouts.caption.body }
            </Caption>
          </LayoutDiv>
            )
    });

    return <Container layouts={ layouts }
                      columnCount={ columnCount }
                      rowCount={ rowCount }
                      supportsGrids={ supportsGrids }
    >{ markup }</Container>
};

Layout.propTypes = {
  layouts: PropTypes.object,
  deviceType: PropTypes.string
};

export default Layout;



// WEBPACK FOOTER //
// ./src/components/Layouts/index.js